<ion-app>

  <div
    *ngIf="showBanner"
    class="profile-warning-banner"
    (click)="goToOnboarding()"
  >{{ 'DASHBOARD.PROFILE_VISIBLE_REQUIRED' | translate }}</div>

  <ion-router-outlet></ion-router-outlet>

  <app-account-type-change-modal></app-account-type-change-modal>

</ion-app>
